/*
 * PVJ - booking (Easy Booking / Servicify)
 *
 * A rescue for the app's "Checkout" button on the confirmation modal it shows
 * once a time has been added to the bag.
 *
 * That button is a plain anchor - <a data-servicify="checkout" href="/checkout">
 * - and the app never navigates in JS. Its whole click handler is:
 *
 *     onClick: e => { loading ? e.preventDefault() : setLoading(true) }
 *
 * Setting loading swaps the label for a spinner; the browser following the link
 * is what actually gets the customer to the checkout. There is no path back out
 * of that flag. So if the first click does not navigate - for any reason at all
 * - the button is left spinning for good, and every further click is swallowed
 * by that preventDefault(). What the customer sees is a modal with a spinning
 * button that will not go to the checkout, and the only way out is reloading the
 * page, which most people will not think to do; they leave instead.
 *
 * So: if a click on that anchor reaches document with its default already
 * cancelled, the app has swallowed it, and we go where the anchor points. The
 * first click is never touched - defaultPrevented is false there and the browser
 * handles it - so the working path stays exactly as it was.
 *
 * Bubble phase on document, which is after React's own handler has had its say:
 * React listens on its root container, well inside document, and its
 * preventDefault is a real one on the native event.
 *
 * Modified and non-left clicks are left alone: cmd-click is the customer asking
 * for a new tab, not for this page to move.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    if (!event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = event.target;

    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest('a[data-servicify="checkout"]');

    if (!link) return;

    var href = link.getAttribute('href');

    if (!href) return;

    window.location.href = href;
  });
})();
